export enum OutcomeStockMovementType {
  USAGE = 'USAGE',
  WASTE = 'WASTE',
  PRODUCTION = 'PRODUCTION',
  SALE = 'SALE',
  TRANSFER = 'TRANSFER',
  INVENTORY_SHORTAGE = 'INVENTORY_SHORTAGE'
}
